import { render } from "./BookList.vue?vue&type=template&id=78cc5ac6&scoped=true&ts=true"
import script from "./BookList.vue?vue&type=script&lang=ts"
export * from "./BookList.vue?vue&type=script&lang=ts"

import "./BookList.vue?vue&type=style&index=0&id=78cc5ac6&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cc5ac6"]])

export default __exports__